module.exports = __webpack_public_path__ + "static/img/jrwm.8f126c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jrwm.png
// module id = Iw0Z
// module chunks = 0